<template>
    <div class="main-content" :style="{ 'min-height': pageMinHeight }">
        <div class="leftTree">
            <el-tree :data="treeData" node-key="type" ref="tree" empty-text="暂无评委数据" :props="cusProps"
                default-expand-all :highlight-current="true" @node-click="handleTreeNodeClick"
                :expand-on-click-node="true">
                <span class="custom-tree-node" slot-scope="{ node }">
                    <span>
                        {{ node.label }}
                    </span>
                </span>
            </el-tree>
        </div>
        <div style="width: calc(100% - 210px);float: right;padding: 15px;border: 1px solid #ebeef5;;">
            <div v-if="currentNode.rootType == 'A'">
                <div class="warnItemWrapper" v-for="(item, index) in tableData" :key="item.id"
                    v-loading="dataListLoading">
                    <div class="iconToolbar-left">
                        {{ index + 1 }}
                    </div>
                    <el-button class="editBtn" type="primary" size="mini" icon="el-icon-edit" plain
                        v-if="hasBtnPermission('btn_jz_warning_ruleseting_edit')"
                        @click="showWarnItemWindow(item)"></el-button>
                    <el-form label-width="150px" class="form viewFormWrapper">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预警项：">
                                    <span>{{ item.itemName }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：">
                                    <span>{{ item.openEnable ? '启用' : '不启用' }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="预警内容：">
                                    <span>{{ item.warnContent }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="普通预警：">
                                    {{ item.genComporName }}<span> {{ item.genLimit }} </span>{{ item.genUnitName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：">
                                    <span>{{ item.genIsOpen ? '启用' : '不启用' }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="严重预警：">
                                    {{ item.seriComporName }}<span> {{ item.seriLimit }} </span>{{ item.seriUnitName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：">
                                    <span>{{ item.seriIsOpen ? '启用' : '不启用' }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="预警接受角色：" style="margin-bottom: 10px">
                                    <span>{{ formatterRoleName(item.notifyRole) || "-" }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div style="min-height:550px" v-if="tableData.length == 0">
                    <emptyInfo :emptyMsg="'暂无见证数据'"></emptyInfo>
                </div>

            </div>



            <div v-if="currentNode.rootType == 'B'">
                <div class="right-content">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>预警基本信息</span>
                        </div>
                        <el-form label-width="110px" ref="warnItemForm2" :model="warnItemForm" :rules='warnrules2'
                            class="form">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="预警项：" prop='itemName' style="width:100%;">
                                        <span v-if="!editWarmItemFlag">{{ warnItemForm.itemName }}</span>
                                        <el-input v-if="editWarmItemFlag" v-model="warnItemForm.itemName" maxlength="50"
                                            show-word-limit></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="预警项编号：" prop='itemCode' style="width:100%;">
                                        <span v-if="!editWarmItemFlag">{{ warnItemForm.itemCode }}</span>
                                        <el-input v-if="editWarmItemFlag" v-model="warnItemForm.itemCode" maxlength="10"
                                            show-word-limit></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="是否开启：" prop="openEnable">
                                        <span v-if="!editWarmItemFlag">{{ warnItemForm.openEnable ? '启用' : '不启用' }}</span>
                                        <el-switch v-if="editWarmItemFlag" v-model="warnItemForm.openEnable"
                                            :active-value="1" :inactive-value="0" active-color="#13ce66"
                                            inactive-color="#c0c0c0">
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="预警内容：" prop='warnContent' style="width:100%;">
                                        <span v-if="!editWarmItemFlag">{{ warnItemForm.warnContent }}</span>
                                        <el-input v-if="editWarmItemFlag" v-model="warnItemForm.warnContent"
                                            maxlength="2000" show-word-limit></el-input>
                                    </el-form-item>

                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">

                                    <el-form-item label="通知角色：" prop='notifyRole' style="width:100%;">
                                        <el-select v-model="roleList" :disabled="!editWarmItemFlag" style="width:100%;"
                                            placeholder="角色多选框" multiple>
                                            <el-option v-for="(item, index) in sysRoleList" :key="item.id"
                                                :label="item.name" :value="item.id"></el-option>
                                        </el-select>

                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                    <el-card class="box-card" style="position: relative" v-if="currentNode.label == '门禁出入预警'">
                        <div slot="header" class="clearfix">
                            <span>预警条件设置</span>
                        </div>
                        <el-form label-width="110px" class="form viewFormWrapper">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="频率条件：">
                                        <span v-if="!editWarmItemFlag">{{ conditionJson.minute }}</span>
                                        <el-input v-if="editWarmItemFlag" v-model="conditionJson.minute" show-word-limit
                                            style="width: 80px;"></el-input>
                                        分钟内，连续出现
                                        <span v-if="!editWarmItemFlag">{{ conditionJson.times }}</span>
                                        <el-input v-model="conditionJson.times" v-if="editWarmItemFlag" show-word-limit
                                            style="width: 80px;"></el-input>
                                        次失败。
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>

                    <el-card class="box-card" v-if="currentNode.label == '人员识别预警'">
                        <div slot="header" class="clearfix">
                            <span>人员白名单</span>
                        </div>
                        <div style="float:right;margin-bottom: 20px">
                            <el-input v-model="form.search" style="width:300px;margin-right: 20px" placeholder="姓名/身份证号"
                                clearable @keydown.enter.native.stop="getWhitePersonList"></el-input>
                            <el-button plain size="small" type="primary" @click="seachBtn">搜索</el-button>
                            <el-button size="small" icon="el-icon-plus" type="primary"
                                v-if="editWarmItemFlag && hasBtnPermission('btn_jz_warning_ruleseting_person_edit')"
                                @click="whitePersonAdd">新增</el-button>
                        </div>
                        <div style="clear:both"></div>

                        <div v-for="(item, index) in whitePersonList" :key="item.id" class="personWrapper">

                            <div class="personHead">
                                <img :src="require('@/assets/images/load_error.png')" class="personImg"
                                    v-real-img="item.headImgUrl" style="width:100%;background:#f8faff " alt="">
                            </div>

                            <el-button style="position:absolute;right:60px;top:10px;z-index: 100" type="primary"
                                size="mini" icon="el-icon-delete"
                                v-if="editWarmItemFlag && hasBtnPermission('btn_jz_warning_ruleseting_person_del')"
                                plain @click="deleteWhitePerson(item)"></el-button>
                            <el-button style="position:absolute;right:10px;top:10px;z-index: 100" type="primary"
                                size="mini" icon="el-icon-edit"
                                v-if="editWarmItemFlag && hasBtnPermission('btn_jz_warning_ruleseting_person_edit')"
                                plain @click="showWhitePersonWindow(item)"></el-button>
                            <el-form label-width="110px" style="width:calc(100% - 150px);margin-left: 150px"
                                class="form viewFormWrapper">
                                <el-row>
                                    <el-col :span="24">
                                        <h2>{{ item.personName }}</h2>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="身份证号：">
                                            <span>{{ item.idcard }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="登记时间：">
                                            <span>{{ item.createTime }}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="允许进入时间：">
                                            <span>{{ item.limitStartTime }}</span> 至 <span>{{ item.limitEndTime }}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <div style="min-height:450px;position: relative" v-if="whitePersonList.length == 0">
                            <emptyInfo :emptyMsg="'暂无白名单数据'"></emptyInfo>
                        </div>
                        <!-- <el-pagination
                              @size-change="sizeChangeHandle"
                              @current-change="currentChangeHandle"
                              :current-page="pageIndex"
                              :page-sizes="[10, 20, 50, 100]"
                              :page-size="pageSize"
                              :total="total"
                              layout="total, sizes, prev, pager, next, jumper"
                      >
                      </el-pagination> -->
                        <pagination class="limit" :page-sizes="[10, 20, 50, 100]" :total="total" :page.sync="pageIndex"
                            :limit.sync="pageSize" @pagination="paginationChange">
                        </pagination>
                    </el-card>


                </div>
                <div class="left-content">
                    <div class="left-navbar">
                        <el-button type="primary" size="small" v-if="!editWarmItemFlag && warmItemId == ''" plain
                            @click="warmItemAdd()">新增</el-button>
                        <el-button type="primary" size="small" v-if="!editWarmItemFlag && warmItemId != ''" plain
                            @click="warmItemEdit()">编辑</el-button>
                        <el-button type="primary" size="small" v-if="editWarmItemFlag" plain
                            @click="activityWarnItemUpdate()">保存</el-button>
                    </div>
                </div>



            </div>

        </div>
        <div style="clear: both"></div>

        <el-dialog title="修改预警配置项" :visible.sync="dialogVisible" width="80%">
            <div class="dialogBox">
                <el-form ref="warnItemForm" :model="warnItemForm" :rules='warnrules' label-width="180px" class="form">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="预警项名称：" prop='itemName' style="width:100%;">
                                <span> {{ warnItemForm.itemName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预警项编号：" prop='itemCode' style="width:100%;">
                                <span> {{ warnItemForm.itemCode }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="开启状态：" prop="openEnable">
                                <el-switch v-model="warnItemForm.openEnable" :disabled="warnItemForm.mustOpen"
                                    :active-value="1" :inactive-value="0" active-color="#13ce66"
                                    inactive-color="#c0c0c0">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="预警内容：" prop='warnContent' style="width:100%;">
                                <el-input v-model="warnItemForm.warnContent" type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4 }" maxlength="2000" show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="普通预警：" prop='genCompor' style="width:100%;">
                                <!--                              {{warnItemForm.genComporName}}-->
                                <el-select v-model="warnItemForm.genCompor" value-key="value"
                                    :disabled="warnItemForm.mustOpen" style="width:30%;margin-right: 5px;">
                                    <el-option v-for="(item, index) in warnComporNamelist" :key="item.value"
                                        :label="item.name" :value="item.value"></el-option>
                                </el-select>
                                <el-input v-model="warnItemForm.genLimit" :disabled="warnItemForm.mustOpen"
                                    show-word-limit style="width: 80px;margin-right: 5px;"></el-input>
                                <!--   {{warnItemForm.genUnit}}-->
                                <el-select v-model="warnItemForm.genUnit" value-key="value"
                                    :disabled="warnItemForm.mustOpen" style="width:30%;margin-right: 5px;">
                                    <el-option v-for="(item, index) in WarnUnitNamelist" :key="item.value"
                                        :label="item.name" :value="item.value"></el-option>
                                </el-select>
                                <el-switch v-model="warnItemForm.genIsOpen" :disabled="warnItemForm.mustOpen"
                                    :active-value="1" :inactive-value="0" active-color="#13ce66"
                                    inactive-color="#c0c0c0">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="严重预警：" prop='genUnit' style="width:100%;">
                                <!--                              {{warnItemForm.seriComporName}}-->
                                <el-select v-model="warnItemForm.seriCompor" value-key="value"
                                    :disabled="warnItemForm.mustOpen" style="width:30%;margin-right: 5px;">
                                    <el-option v-for="(item, index) in warnComporNamelist" :key="item.value"
                                        :label="item.name" :value="item.value"></el-option>
                                </el-select>
                                <el-input v-model="warnItemForm.seriLimit" :disabled="warnItemForm.mustOpen"
                                    show-word-limit style="width: 80px;margin-right: 5px;"></el-input>
                                <!--                              {{warnItemForm.seriUnit}}-->
                                <el-select v-model="warnItemForm.seriUnit" value-key="value"
                                    :disabled="warnItemForm.mustOpen" style="width:30%;margin-right: 5px;">
                                    <el-option v-for="(item, index) in WarnUnitNamelist" :key="item.value"
                                        :label="item.name" :value="item.value"></el-option>
                                </el-select>
                                <el-switch v-model="warnItemForm.seriIsOpen" :disabled="warnItemForm.mustOpen"
                                    :active-value="1" :inactive-value="0" active-color="#13ce66"
                                    inactive-color="#c0c0c0">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>

                        <el-col :span="24">
                            <el-form-item label="预警接受角色：" prop='notifyRole' style="width:100%;">
                                <el-select v-model="roleList" style="width:100%;" placeholder="角色多选框" multiple>
                                    <el-option v-for="(item, index) in sysRoleList" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="warnItemUpdate" style="margin-bottom:20px;">保存</el-button>
                <el-button @click="closeDialog()" class="backBtn">返回</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="whitePersonForm.id != '' ? '修改白名单人员' : '新增白名单人员'" :visible.sync="dialogPersonVisible" width="60%">
            <div class="dialogBox">
                <el-form ref="whitePersonForm" :model="whitePersonForm" :rules='whitePersonFormRules'
                    label-width="120px" class="form">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="人员头像：" prop='headImgUrl' style="width:100%;">
                                <!--                              -->
                                <img :src="require('@/assets/images/load_error.png')"
                                    v-real-img="whitePersonForm.headImgUrl" class="personImg">
                                <br>
                                <input type="file" style="visibility: hidden;display: none"
                                    accept="image/png,image/jpeg,image/jpg,image/gif,image/svg" name="headImgUrl"
                                    id="headImgUrl" @change="getUploadFile" ref="inputFile">
                                <el-button type="defualt" icon="el-icon-upload" size="small"
                                    @click="localUploadFile">本地上传</el-button>

                                <el-button type="default" icon="el-icon-camera" size="small"
                                    @click="cameraDialogVisible = true">拍摄照片</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="姓名：" prop='personName' style="width:100%;">
                                <el-input v-model="whitePersonForm.personName" maxlength="6" show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="身份证号：" prop='idcard' style="width:100%;">
                                <el-input v-model="whitePersonForm.idcard" maxlength="18" show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="允许进入时间：" prop='datetimerange' style="width:100%;"
                                :error="starttimeerror">
                                <el-date-picker style="width: 100%" v-model="datetimerange" type="datetimerange"
                                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
                                    start-placeholder="开始日期" :picker-options="endDateTimeOption" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>


                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updatePersonInfo" style="margin-bottom:20px;">保存</el-button>
                <el-button @click="closeDialog()" class="backBtn">返回</el-button>
            </span>
        </el-dialog>

        <!-- 拍摄照片弹窗 -->
        <CameraDialog :dialogVisible.sync="cameraDialogVisible" @dialogCancle="dialogCancleCamera" />




    </div>
</template>

<script>
import emptyInfo from '@/components/empty-info';
import CameraDialog from "@/components/cameraDialog";
import { isIdcard, isInteger, strLength_1, strLength_5, validateDate } from "@/utils/validate";
import Pagination from '@/components/Pagination.vue';
export default {
    components: {
        emptyInfo,
        CameraDialog,
        Pagination
    },
    data() {
        return {
            busType: "GC",
            pageMinHeight: document.documentElement.clientHeight - 108 + 'px',
            cusProps: {
                children: 'children',
                label: 'label',
            },

            fileId: '',
            emptyArr: [],
            cameraDialogVisible: false,
            editWarmItemFlag: false,
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            form: {
                search: "",
            },
            endDateTimeOption: {
                disabledDate(time) {
                    return time.getTime() < new Date() - 24 * 60 * 60 * 1000;
                }
            },
            sysRoleList: [],
            roleList: [],
            dialogVisible: false,
            dialogPersonVisible: false,
            currentNode: {
                rootType: "A",
                type: "",
                label: ""
            },
            warnItemForm: {
                id: '', //预警项id
                flowId: '', //节点id
                warnType: '', //预警类型
                warnTypeName: '',
                mustOpen: true, // 必须启用
                itemName: '', //预警项名称
                itemCode: '', //预警项编号
                openEnable: 1, //是否开启 0关闭 1开启
                genIsOpen: 1, //普通级别是否启用 0关闭 1开启
                seriIsOpen: 1, //严重级别是否启用 0关闭 1开启
                warnContent: '', //预警内容
                notifyRole: "", //通知角色id集合
                genCompor: '', //普通级别比较符
                genLimit: '', //普通级别阈值
                genUnit: '', //普通级别单位
                seriCompor: '', //严重级别比较符
                seriLimit: '', //严重级别阈值
                seriUnit: '', //严重级别单位
                sort: '', //排序

            },
            conditionJson: {
                minute: null,
                times: null,
            },
            datetimerange: [],
            warnrules2: {

                itemName: [{ required: true, message: '请输入预警项名称', trigger: 'blur' }, {
                    validator: strLength_5,
                    trigger: 'blur'
                }],
                itemCode: [{ required: true, message: '请输入预警项编号', trigger: 'blur' }, {
                    validator: strLength_1,
                    trigger: 'blur'
                }],

            },
            warnComporNamelist: [],
            WarnUnitNamelist: [],
            warnrules: {
                genLimit: [{
                    validator: isInteger,
                    trigger: 'blur'
                }],
                seriLimit: [{
                    validator: isInteger,
                    trigger: 'blur'
                }],
            },
            whitePersonForm: {
                headImgUrl: "",
                id: "1",
                idcard: "32189451901223419",
                limitEndTime: "2021-05-09 05:00:48",
                limitStartTime: "2021-03-09 06:00:45",
                personName: "马云",
            },
            whitePersonFormRules: {
                headImgUrl: [{ required: true, message: '请上传人员头像', trigger: 'blur' }],
                datetimerange: [{ type: 'date', required: true, validator: validateDate, message: '请选择起止日期', trigger: 'change' }],
                personName: [{ required: true, message: '请输入姓名', trigger: 'blur' }, { min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }],
                idcard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }, {
                    validator: isIdcard,
                    trigger: 'blur'
                }],
            },
            treeData: [],
            tableData: [],
            dataListLoading: false,
            whitePersonList: [],
            errorData: {},
        };
    },

    computed: {
        warmItemId: function () {
            return this.warnItemForm.id;
        },
        starttimeerror: function () {
            return this.errorData.starttime;
        },
    },
    created() {
        this.getRoleList();
        this.getDic('jz_dgwitness_warn_compor');
        this.getDic('jz_dgwitness_warn_unit');
    },
    activated() {

        this.getTreeData()

    },

    methods: {


        //本地获取人脸照片
        getUploadFile() {

            let arr = ['png', 'jpg', 'jpeg', 'gif', 'svg'];
            let input = document.getElementById('headImgUrl')
            let file = input.files[0];
            // 获取文件类型
            let type = file.name.substr(file.name.lastIndexOf(".") + 1);
            if (arr.indexOf(type.toLowerCase()) !== -1) {
                this.setFileUpload(file)
            } else {
                this.$message({ message: '请选择图片类型的文件，如：png，jpg，jpeg，gif，svg', type: "error" });
            }

        },
        //上传人脸照片
        setFileUpload(file) {
            const formData = new FormData();
            formData.append('file', file);

            if (file) {

                // 校验人脸信息
                this.$http.post('/document/sysPersonFaces/faceDetect', formData).then(res => {
                    if (res.data.code == '1' && res.data.data == 1) {

                        this.$http.post('/bigfileUpload/uploadFile', formData).then(res => {
                            if (res.data.code == "1") {
                                var filePath = res.data.data;
                                this.whitePersonForm.headImgUrl = filePath;
                                this.$message({ message: "上传成功", type: "success" });
                            } else {
                                this.$message({ message: "上传失败", type: "error" });
                            }
                        }).catch(e => { })

                    } else {
                        this.$message({ message: "未捕获到人脸信息或人脸信息超出，要求有且仅有一张有效人脸信息。", type: "error" });
                    }
                }).catch(e => {
                    this.$message({ message: "上传失败", type: "error" });
                })


            }

        },

        //转base64
        getBase64(file) {
            return new Promise(function (resolve, reject) {
                let reader = new FileReader();
                let imgResult = "";
                reader.readAsDataURL(file);
                reader.onload = function () {
                    imgResult = reader.result;
                };
                reader.onerror = function (error) {
                    reject(error);
                };
                reader.onloadend = function () {
                    resolve(imgResult);
                };
            });
        },
        // 将base64 图片转为 blob文件
        convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], { type: 'image/png' });
        },
        //删除人脸照片
        deleteUploadFile() {
            this.$confirm(`确认删除?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

            }).catch(() => { });
        },

        localUploadFile() {
            this.$refs.inputFile.click()
        },


        //Dialog弹窗取消、获取上传人脸照片
        dialogCancleCamera(fileId, imagePath) {
            if (fileId) {
                this.fileId = fileId
            }

            if (imagePath) {
                this.whitePersonForm.headImgUrl = imagePath;
            }
            this.cameraDialogVisible = false;

        },

        getRoleList() { // 获取字典
            this.$http.get('/sys/role/list').then(res => {
                if (res.data.code === '1') {
                    this.sysRoleList = res.data.data;
                }
            })
        },
        formatterRoleName(notifyRole) {
            const _this = this;
            let notifyRoleName = [];
            if (notifyRole) {
                let notifyRoleArr = notifyRole.split(",");
                notifyRoleArr.forEach((item, index) => {
                    let name = _this.formatterDataDictionary(_this.sysRoleList, item);
                    if (name) {
                        notifyRoleName.push(name)
                    }
                })
            }
            return notifyRoleName.toString()

        },
        formatterDataDictionary(list, value) {
            const item = list.filter(sl => sl.id == value)[0];
            return item != null ? item.name : "";
        },

        handleTreeNodeClick(data) {
            if (data.type == 'C') {
                this.currentNode = { ...data };
                this.tableData = [
                    {
                        "attributes": {
                            "genCompor": "小于",
                            "genUnit": "日",
                            "seriUnit": "日",
                            "seriCompor": "小于"
                        },
                        "canModify": false,
                        "createTime": "2021-04-13 15:16:28",
                        "createUser": "admin",
                        "delFlag": false,
                        "flowId": "e0b69e784bc14c9780e96e04e6af8caa",
                        "genCompor": 1,
                        "genComporName": "大于【",
                        "genIsOpen": 1,
                        "genLimit": 60,
                        "genUnit": "1",
                        "genUnitName": "】分钟",
                        "id": "08ddb51067b743ddaa3e320c396f1234",
                        "itemCode": "GC-1-1-2",
                        "itemName": "解密时间",
                        "mustOpen": false,
                        "notifyRole": "8d73fcc292a749899e39aac43f44fdc6,cc3a898745504410a0602cdd573e9c39,b76899eff675472799c61fb9332b0b71",
                        "openEnable": 1,
                        "rootId": "08ddb51067b743ddaa3e320c396f1234",
                        "seriCompor": 1,
                        "seriComporName": "大于【",
                        "seriIsOpen": true,
                        "seriLimit": 120,
                        "seriUnit": "1",
                        "seriUnitName": "】分钟",
                        "sort": 1,
                        "updateTime": "2021-08-06 17:06:56",
                        "updateUser": "supperadmin",
                        "warnContent": "招标代理设置解密总时长过长",
                        "warnType": 1
                    },
                    {
                        "attributes": {
                            "genCompor": "小于",
                            "genUnit": "日",
                            "seriUnit": "日",
                            "seriCompor": "小于"
                        },
                        "canModify": false,
                        "createTime": "2021-08-06 18:26:55",
                        "createUser": "admin",
                        "delFlag": false,
                        "flowId": "08ddb51067b743ddaa3e320c396f6c30",
                        "genCompor": 1,
                        "genComporName": "大于【",
                        "genIsOpen": 1,
                        "genLimit": 1,
                        "genUnit": "1",
                        "genUnitName": "】分钟",
                        "id": "3dc1e51414ca4ea99e844ac87a7ff5d3",
                        "itemCode": "GC-1-1-1",
                        "itemName": "提议次数",
                        "mustOpen": false,
                        "notifyRole": "8d73fcc292a749899e39aac43f44fdc6,cc3a898745504410a0602cdd573e9c39,b76899eff675472799c61fb9332b0b71",
                        "openEnable": 1,
                        "rootId": "08ddb51067b743ddaa3e320c396f6c30",
                        "seriCompor": 1,
                        "seriComporName": "大于【",
                        "seriIsOpen": true,
                        "seriLimit": 5,
                        "seriUnit": "1",
                        "seriUnitName": "】分钟",
                        "sort": 1,
                        "updateTime": "2021-06-02 11:19:46",
                        "updateUser": "supperadmin",
                        "warnContent": "投标人提议的总次数过多",
                        "warnType": 1
                    },
                    {
                        "attributes": {
                            "genCompor": "小于",
                            "genUnit": "日",
                            "seriUnit": "日",
                            "seriCompor": "小于"
                        },
                        "canModify": false,
                        "createTime": "2022-11-17 15:11:10",
                        "createUser": "admin",
                        "delFlag": false,
                        "flowId": "8646565eb0e845559d990de8afeb8d48",
                        "genCompor": 1,
                        "genComporName": "大于等于平均值的【",
                        "genIsOpen": 1,
                        "genLimit": 100,
                        "genUnit": "1",
                        "genUnitName": "】%",
                        "id": "cc78177fa2cb44f785c3a291191dce82",
                        "itemCode": "GC-1-1-3",
                        "itemName": "评审时长异常",
                        "mustOpen": false,
                        "notifyRole": "8d73fcc292a749899e39aac43f44fdc6,cc3a898745504410a0602cdd573e9c39,b76899eff675472799c61fb9332b0b71",
                        "openEnable": 1,
                        "rootId": "1ae6d038d3ec11ebb985525400761015",
                        "seriCompor": 1,
                        "seriComporName": "大于等于平均值的【",
                        "seriIsOpen": true,
                        "seriLimit": 300,
                        "seriUnit": "1",
                        "seriUnitName": "】%",
                        "sort": 1,
                        "updateTime": "2021-06-02 11:19:46",
                        "updateUser": "supperadmin",
                        "warnContent": "每个专家在打分制节点的评审时长过长",
                        "warnType": 1
                    },
                    {
                        "attributes": {
                            "genCompor": "小于",
                            "genUnit": "日",
                            "seriUnit": "日",
                            "seriCompor": "小于"
                        },
                        "canModify": false,
                        "createTime": "2022-11-17 15:11:10",
                        "createUser": "admin",
                        "delFlag": false,
                        "flowId": "8646565eb0e845559d990de8afeb8d48",
                        "genCompor": 1,
                        "genComporName": "发起流程跳转的次数大于等于【",
                        "genIsOpen": 1,
                        "genLimit": 1,
                        "genUnit": "1",
                        "genUnitName": "】次",
                        "id": "cc78177fa2cb44f785c3a291191dce82",
                        "itemCode": "GC-1-1-3",
                        "itemName": "评审流程跳转",
                        "mustOpen": false,
                        "notifyRole": "8d73fcc292a749899e39aac43f44fdc6,cc3a898745504410a0602cdd573e9c39,b76899eff675472799c61fb9332b0b71",
                        "openEnable": 1,
                        "rootId": "1ae6d038d3ec11ebb985525400761015",
                        "seriCompor": 1,
                        "seriComporName": "发起流程跳转的次数大于等于【",
                        "seriIsOpen": true,
                        "seriLimit": 3,
                        "seriUnit": "1",
                        "seriUnitName": "】次",
                        "sort": 1,
                        "updateTime": "2021-06-02 11:19:46",
                        "updateUser": "supperadmin",
                        "warnContent": "评标过程中出现打分制节点跳转至打分制节点的情况",
                        "warnType": 1
                    },
                    {
                        "attributes": {
                            "genCompor": "小于",
                            "genUnit": "日",
                            "seriUnit": "日",
                            "seriCompor": "小于"
                        },
                        "canModify": false,
                        "createTime": "2022-11-17 15:11:10",
                        "createUser": "admin",
                        "delFlag": false,
                        "flowId": "8646565eb0e845559d990de8afeb8d48",
                        "genCompor": 1,
                        "genComporName": "雷同单位大于等于【",
                        "genIsOpen": 1,
                        "genLimit": 1,
                        "genUnit": "1",
                        "genUnitName": "】组",
                        "id": "cc78177fa2cb44f785c3a291191dce82",
                        "itemCode": "GC-1-1-3",
                        "itemName": "制作投标文件IP地址",
                        "mustOpen": false,
                        "notifyRole": "8d73fcc292a749899e39aac43f44fdc6,cc3a898745504410a0602cdd573e9c39,b76899eff675472799c61fb9332b0b71",
                        "openEnable": 1,
                        "rootId": "1ae6d038d3ec11ebb985525400761015",
                        "seriCompor": 1,
                        "seriComporName": "雷同单位大于等于【",
                        "seriIsOpen": true,
                        "seriLimit": 3,
                        "seriUnit": "1",
                        "seriUnitName": "】组",
                        "sort": 1,
                        "updateTime": "2021-06-02 11:19:46",
                        "updateUser": "supperadmin",
                        "warnContent": "投标单位的IP地址信息雷同",
                        "warnType": 1
                    },
                ]
            } else if (data.level == 3) {
                this.getTableList(data)
            }
        },
        showWarnItemWindow(item) {
            this.warnItemForm = { ...item };
            this.warnItemForm.genCompor = { ...item }.genCompor.toString();
            this.warnItemForm.seriCompor = { ...item }.seriCompor.toString();
            this.warnItemForm.genIsOpen = item.genIsOpen == true ? 1 : 0;
            this.warnItemForm.seriIsOpen = item.seriIsOpen == true ? 1 : 0;
            this.dialogVisible = true;
            this.roleList = item.notifyRole ? item.notifyRole.split(",") : [];
        },

        //搜索按钮
        seachBtn() {
            this.pageIndex = 1;
            this.getWhitePersonList();

        },
        whitePersonAdd() {


            this.whitePersonForm = {
                canModify: false,
                createTime: "",
                createUser: "",
                fileTypeDictCode: "",
                headImgUrl: "",
                id: "",
                idcard: "",
                limitEndTime: "",
                limitStartTime: "",
                personName: "",
            };
            this.whitePersonForm.headImgUrl = require('@/assets/images/load_error.png')
            this.datetimerange = [];
            this.dialogPersonVisible = true;

        },
        showWhitePersonWindow(item) {

            this.whitePersonForm = { ...item };
            this.whitePersonForm.headImgUrl = item.headImgUrl
            if (this.whitePersonForm.limitStartTime || this.whitePersonForm.limitEndTime) {
                this.datetimerange = [new Date(this.whitePersonForm.limitStartTime.replace(/-/g, "/")), new Date(this.whitePersonForm.limitEndTime.replace(/-/g, "/"))]
            } else {
                this.datetimerange = []
            }
            this.dialogPersonVisible = true;

        },
        // 删除人员白名单人员
        deleteWhitePerson(item) {

            this.$http.post('/person/sysWhiteList/delete', {
                id: item.id
            }).then(res => {
                if (res.data.code == '1') {
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    })
                    this.getWhitePersonList();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            })

        },



        closeDialog() {
            if (this.dialogVisible) {
                this.dialogVisible = false;
                this.$refs.warnItemForm.resetFields();
            }
            if (this.dialogPersonVisible) {
                this.dialogPersonVisible = false;
                this.$refs.whitePersonForm.resetFields();
            }
        },


        getTreeData() {

            this.dataListLoading = true
            this.$http({
                url: `/warnItem/getWarnItemTree`,
                method: 'get'
            }).then(({ data }) => {
                if (data) {

                    this.treeData = [...data.data,{
                                    "label": "开评标活动预警",
                                    "level": 1,
                                    "rootType": "A",
                                    "type": "C"
                                }];

                    var firstLeafNodeId = '1';
                    if (firstLeafNodeId != '') {
                        this.$nextTick(function () {
                            let node = this.$refs.tree.getNode(firstLeafNodeId)
                            if (node) {
                                this.$refs.tree.setCurrentKey(node);

                                this.getTableList(node.data);
                            }
                        })
                    }

                } else {
                    this.tableData = []
                }
                this.dataListLoading = false
            })
        },
        //
        getRowsIndex(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getWhitePersonList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getWhitePersonList();
        },
        paginationChange(obj) {
            this.pageIndex = obj.page || 1
            this.pageSize = obj.limit || 10
            this.getWhitePersonList();
        },
        getWhitePersonList() {
            this.$http({
                url: `/person/sysWhiteList/list`,
                method: 'post',
                data: {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    filter: {},
                    searchKey: this.form.search
                }
            }).then(({ data }) => {
                if (data) {
                    this.whitePersonList = data.rows
                    this.total = data.total
                } else {
                    this.whitePersonList = [];
                    this.total = 0;
                }
            })
        },



        // 获取交易数据预警表格数据
        getTableList(data) {

            if (data) {
                this.currentNode = { ...data };
            }
            this.dataListLoading = true;
            this.$http({
                url: `/warnItem/listWarnItemBuType?warnType=` + this.currentNode.type,
                method: 'get'
            }).then(({ data }) => {
                if (data) {
                    this.tableData = data.data;
                    this.dataListLoading = false;
                    if (this.currentNode.rootType == 'B') {
                        this.editWarmItemFlag = false;
                        this.warnItemForm = this.tableData[0] || {
                            id: '', //预警项id
                            flowId: '', //节点id
                            warnType: '', //预警类型
                            warnTypeName: '',
                            itemName: '', //预警项名称
                            itemCode: '', //预警项编号
                            openEnable: 1, //是否开启 0关闭 1开启
                            genIsOpen: 0, //普通级别是否启用 0关闭 1开启
                            seriIsOpen: 0, //严重级别是否启用 0关闭 1开启
                            warnContent: '', //预警内容
                            notifyRole: "", //通知角色id集合
                            genCompor: '', //普通级别比较符
                            genLimit: '', //普通级别阈值
                            genUnit: '', //普通级别单位
                            seriCompor: '', //严重级别比较符
                            seriLimit: '', //严重级别阈值
                            seriUnit: '', //严重级别单位
                            sort: '', //排序
                        }
                        this.conditionJson = (this.tableData[0] && this.tableData[0].conditionJson) ? JSON.parse(this.tableData[0].conditionJson) : {
                            minute: null,
                            times: null,
                        }
                    }
                    this.roleList = this.warnItemForm.notifyRole != '' ? this.warnItemForm.notifyRole.split(",") : [];
                    // 如果节点是人员识别预警 ，则要查询人员白名单数据
                    if (this.currentNode.label == '人员识别预警') {
                        this.form.search = '';
                        this.getWhitePersonList()
                    }

                } else {
                    this.tableData = []
                }

            })

        },

        updatePersonInfo() {

            this.whitePersonForm.limitStartTime = this.datetimerange[0] ? this.datetimerange[0] : "";
            this.whitePersonForm.limitEndTime = this.datetimerange[1] ? this.datetimerange[1] : "";
            if (this.datetimerange.length == 0) {
                this.errorData = {
                    starttime: "日期不能为空"
                }
                return
            } else {
                this.errorData.starttime = '';
            }

            this.$refs['whitePersonForm'].validate((valid) => {
                if (valid) {

                    this.$http({
                        url: '/person/sysWhiteList/save',
                        method: 'post',
                        data: this.whitePersonForm
                    }).then(({ data }) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '更新成功',
                                type: 'success'
                            });
                            this.closeDialog()
                            this.getWhitePersonList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: data.msg
                            })

                        }
                    })

                }
            })





        },
        warmItemAdd() {

            this.warnItemForm = {
                id: '', //预警项id
                flowId: '', //节点id
                warnType: '', //预警类型
                warnTypeName: '',
                itemName: '', //预警项名称
                itemCode: '', //预警项编号
                openEnable: 1, //是否开启 0关闭 1开启
                genIsOpen: 1, //普通级别是否启用 0关闭 1开启
                seriIsOpen: 1, //严重级别是否启用 0关闭 1开启
                warnContent: '', //预警内容
                notifyRole: "", //通知角色id集合
                genCompor: '', //普通级别比较符
                genLimit: '', //普通级别阈值
                genUnit: '', //普通级别单位
                seriCompor: '', //严重级别比较符
                seriLimit: '', //严重级别阈值
                seriUnit: '', //严重级别单位
                sort: '', //排序
            };
            this.roleList = [];
            this.editWarmItemFlag = true;
        },
        warmItemEdit() {

            this.editWarmItemFlag = true;
            this.roleList = this.warnItemForm.notifyRole != '' ? this.warnItemForm.notifyRole.split(",") : [];

        },

        // 交易活动预警项 保存或者更新
        activityWarnItemUpdate() {


            this.$refs['warnItemForm2'].validate((valid) => {
                if (valid) {
                    this.warnItemForm.notifyRole = this.roleList.toString();
                    this.$http({
                        url: '/warnItem/saveOrUpdate',
                        method: 'post',
                        data: {
                            'id': this.warnItemForm.id,
                            'itemName': this.warnItemForm.itemName,
                            'itemCode': this.warnItemForm.itemCode,
                            'openEnable': this.warnItemForm.openEnable,
                            'warnType': this.currentNode.type,
                            'warnContent': this.warnItemForm.warnContent,
                            'genIsOpen': '1',
                            'seriIsOpen': '0',
                            'genLimit': this.warnItemForm.genLimit,
                            'notifyRole': this.warnItemForm.notifyRole,
                            "conditionJson": JSON.stringify(this.conditionJson),
                        }
                    }).then(({ data }) => {
                        if (data && data.code === '1') {

                            this.closeDialog();
                            this.editWarmItemFlag = false;
                            this.$message({
                                message: '更新成功',
                                type: 'success'
                            });
                            this.getTableList('');
                        } else {
                            this.$message({
                                type: 'error',
                                message: data.msg
                            })
                        }
                    })


                }
            })




        },

        warnItemUpdate() {

            this.$refs['warnItemForm'].validate((valid) => {
                if (valid) {
                    this.warnItemForm.notifyRole = this.roleList.toString();
                    this.$http({
                        url: '/warnItem/saveOrUpdate',
                        method: 'post',
                        data: this.warnItemForm
                        /*    data: {
                            'id': this.warnItemForm.id,
                              'openEnable':  this.warnItemForm.openEnable,
                              'genIsOpen':  this.warnItemForm.genIsOpen,
                              'seriIsOpen':  this.warnItemForm.seriIsOpen,
                              'genLimit': this.warnItemForm.genLimit,
                              'seriLimit':  this.warnItemForm.seriLimit,
                              'notifyRole':  this.warnItemForm.notifyRole,
                            'genCompor':this.warnItemForm.genCompor,
                            'seriCompor':this.warnItemForm.seriCompor
  
                          }*/
                    }).then(({ data }) => {
                        if (data && data.code === '1') {

                            this.closeDialog();
                            this.editWarmItemFlag = false;
                            this.$message({
                                message: '更新成功',
                                type: 'success'
                            });
                            this.getTableList('');
                        } else {
                            this.$message({
                                type: 'error',
                                message: data.msg
                            })
                        }
                    })

                }
            })


        },

        getDic(type) { // 获取字典
            this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
                if (res.data.code === '1') {
                    switch (type) {
                        case 'jz_dgwitness_warn_compor':
                            this.warnComporNamelist = res.data.data;
                            break;
                        case 'jz_dgwitness_warn_unit':
                            this.WarnUnitNamelist = res.data.data;
                            break;
                    }
                }
            })
        },

    },
    mounted() {

    },
};
</script>
<style lang="less" scoped>
.personImg {
    width: 150px;
    margin-bottom: 4px;
    /*background-color: #f8faff;*/
    /*border:1px solid #c0c4cc;*/
}

.main-content {
    .leftTree {
        width: 200px;
        float: left;
        border: 1px solid #ebeef5;
        margin-bottom: 20px;
        margin-right: 10px;
        padding: 10px 0px;


        .iconImg {
            width: 14px;
        }


        /deep/ .el-tree-node__content {
            /deep/ .el-icon-folder {
                padding: 0;
                display: none;
            }
        }

        .el-tree--highlight-current {
            /deep/ .el-tree-node.is-current {
                >.el-tree-node__content {
                    background-color: #1965FF;
                    color: #FFFFFF;
                }
            }
        }

        ::v-deep.el-tree-node__content {
            &:hover {
                background-color: #1965FF;
                color: #FFFFFF;
            }
        }


        .custom-tree-node {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        /deep/ span.is-leaf {
            padding: 0 !important;
        }


    }

    .personWrapper {
        position: relative;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 10px;

        .personHead {
            width: 120px;
            margin-left: 10px;
            position: absolute;
            left: 0;
            top: 10px;
        }

        h2 {
            margin-bottom: 6px;
        }

        .viewFormWrapper {
            margin-bottom: 15px;
        }
    }

    .personWrapper:last-child {
        border-bottom: none;
    }

    .warnItemWrapper {
        position: relative;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 10px;

        .el-button.editBtn {
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 100
        }

        .iconToolbar-left {
            font-weight: bold;
            color: #fff;
            text-align: center;
            padding-top: 3px;
            position: absolute;
            top: 10px;
            left: 10px;
            width: 32px;
            height: 32px;
            background: url("../../../assets/img/bookmark.png")no-repeat;
        }
    }

    .warnItemWrapper:last-child {
        border-bottom: none;
    }


}
</style>
